<template>
  <PanelPrint
    :title="$t(`enums.engineering.chromatography.rules.${rule}`)"
  >
    <div class="rule-panel__print-design"
      :class="containerClassObject"
    >
      <component
        v-for="methodData in methodsToShow"
        :key="methodData.method"
        :is="getContentComponent(methodData)"
        :data="methodData"
        :norm="rule"
      />
    </div>
  </PanelPrint>
</template>

<script>
import PanelPrint from './PanelPrint';
import cardContents from './cardContents';
import NotExecutedPrint from './cardContents/NotExecuted';

export default {
  name: 'RulePanelPrint',
  components: {
    PanelPrint,
    NotExecutedPrint,
  },
  props: {
    rule: String,
    methods: Array,
    showOnlyAlarmedMethods: Boolean,
  },
  computed: {
    layoutDirection() {
      return cardContents[this.rule].direction;
    },
    containerClassObject() {
      return {
        'rule-panel__triangle-design': this.layoutDirection === 'row',
      };
    },
    methodsToShow() {
      if (this.showOnlyAlarmedMethods) {
        return this.methods.filter(({ alarmed }) => alarmed);
      }

      return this.methods;
    },
  },
  methods: {
    getCardDefinition(method) {
      return cardContents[this.rule][method];
    },
    getContentComponent(methodData) {
      if (methodData.executed) {
        return this.getCardDefinition(methodData.method).content;
      }

      return NotExecutedPrint;
    },
  },
};
</script>
<style lang="sass" scoped>
  .rule-panel
    &__triangle-design
      display: flex !important
      flex-wrap: wrap !important
  @media print
    .rule-panel
      &__print-design
        display: block
        float: none

</style>
